import { DefaultLoginUrl } from '@/infrastructure/adapters/environment-variables';
import { useUserStore } from '@/infrastructure/store/user';
import { NavigationGuard, NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export const AuthHandler: NavigationGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (to.meta?.authorize) {
    const loggedOn = await useUserStore().gettingUserInfo();
    if (!loggedOn) {
      location.replace(`${DefaultLoginUrl}?returnUrl=${to.path}`);
      return;
    }
  }
  next();
};
